import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/site";
import { Reveal } from "./Reveal";

export default function Services() {
  return (
    <section id="services" className="py-24 sm:py-32 bg-[#0D0D0D]" data-testid="services-section">
      <div className="container-lux">
        <Reveal className="max-w-3xl">
          <p className="overline mb-3">Our Services</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            Complete roofing <span className="text-gold-metallic">craftsmanship.</span>
          </h2>
          <p className="mt-4 text-[#C8C8C8]">From a single slipped tile to a full new roof — every project across Stockport, Greater Manchester and Cheshire is delivered to the same exacting standard.</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Home;
            return (
              <Reveal key={s.slug} delay={(i % 3) * 0.08}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                  className="group block h-full glass rounded-md overflow-hidden hover:border-[#D4AF37]/60 hover:-translate-y-2 transition-[transform,border-color] duration-400">
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img src={s.img} alt={s.title} loading="lazy" decoding="async"
                      className="w-full h-full object-cover group-hover:scale-[1.08] transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/20 to-transparent" />
                    <div className="absolute bottom-3 left-4 w-11 h-11 rounded-sm bg-[#0D0D0D]/70 backdrop-blur border border-white/10 flex items-center justify-center group-hover:border-[#D4AF37]/50 transition-colors">
                      <Icon size={22} strokeWidth={1.4} className="text-[#D4AF37]" />
                    </div>
                  </div>
                  <div className="p-6 pt-4">
                    <h3 className="font-head text-2xl uppercase tracking-tight mb-2">{s.title}</h3>
                    <p className="text-sm text-[#C8C8C8] leading-relaxed">{s.blurb}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-xs uppercase tracking-wider text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity">
                      Learn More <ArrowUpRight size={14} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
